import localforage from 'localforage'
import versionInfo from './versionInfo.json'

export default {
  getVersionDisplayContent: function () {
    let ac = versionInfo.reduce((a, i) => { return a + '<li>' + i + '</li>' }, '')
    return `
    <div class='version-div-w'>
      <ol class='version-ul-pd'>
        ${ac}
      </ol>
    </div>
    `
  },
  isValidVersion (v) {
    try {
      const latest = v.split('.')
      const current = process.env.VUE_APP_VERSION.split('.')
      return (
        current[0] === latest[0] &&
        current[1] === latest[1] &&
        current[2] === latest[2]
      )
    } catch (e) {
      console.error(e.message)
      return false
    }
  },
  async isDetectedNewVersion () {
    try {
      const version = await localforage.getItem('manager-version')
      if (version === null || version !== process.env.VUE_APP_VERSION) {
        await localforage.setItem('manager-version', process.env.VUE_APP_VERSION)
        return true
      }
      // await localforage.setItem('manager-version', '0')
    } catch (e) {
      console.error(e.message)
      return false
    }
  }
}
